import { IApiError } from '@frontend/request';

import {
  IDeleteNotificationParams,
  IGetNotificationParams,
  INotification,
  INotificationSettings,
  INotificationSummary,
  IUpdateNotificationParams,
  notificationAPI
} from '@aqx-core/common/api/notification';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

class NotificationAPIController {
  public deleteNotification = async (
    params: IDeleteNotificationParams,
    callbacks: IAPIControllerCallbacks<boolean>
  ) => {
    try {
      const { result } = await notificationAPI.deleteNotification(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getNotificationSettings = async (callbacks: IAPIControllerCallbacks<INotificationSettings[]>) => {
    try {
      const { result } = await notificationAPI.getNotificationSettings();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public updateNotificationSettings = async (
    params: IUpdateNotificationParams[],
    callbacks: IAPIControllerCallbacks<boolean>
  ) => {
    try {
      const { result } = await notificationAPI.updateNotificationSettings(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getUnreadNotificationCount = async (callbacks: IAPIControllerCallbacks<INotificationSummary[]>) => {
    try {
      const { result } = await notificationAPI.getUnreadNotificationCount();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getNotifications = async (
    params: IGetNotificationParams,
    callbacks: IAPIControllerCallbacks<INotification[]>
  ) => {
    try {
      const { result } = await notificationAPI.getNotifications(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const notificationAPIController = new NotificationAPIController();
